var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63334 5.0809C6.00565 4.89203 6.45838 5.04514 6.64453 5.42288L8.13037 8.43791C9.2307 8.03688 10.5121 7.80405 12 7.80405C13.1111 7.80405 14.107 7.93389 14.9984 8.16664L16.3505 5.42288C16.5367 5.04514 16.9894 4.89203 17.3617 5.0809C17.734 5.26977 17.8849 5.7291 17.6988 6.10685L16.4374 8.66646C20.3039 10.3763 21.7161 14.2652 21.9951 16.9827C22.0526 17.5428 21.5994 18 21.0444 18H2.9556C2.4006 18 1.94744 17.5428 2.00493 16.9827C2.26358 14.4627 3.49679 10.9355 6.75782 9.07258L5.29627 6.10685C5.11012 5.7291 5.26103 5.26977 5.63334 5.0809ZM17.0247 13.9215C17.0247 13.3583 16.5747 12.9019 16.0197 12.9019C15.4647 12.9019 15.0148 13.3583 15.0148 13.9215C15.0148 14.4846 15.4647 14.941 16.0197 14.941C16.5747 14.941 17.0247 14.4846 17.0247 13.9215ZM7.98027 14.941C8.53528 14.941 8.9852 14.4846 8.9852 13.9215C8.9852 13.3583 8.53528 12.9019 7.98027 12.9019C7.42526 12.9019 6.97533 13.3583 6.97533 13.9215C6.97533 14.4846 7.42526 14.941 7.98027 14.941Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.f446b9fd25e437322951111ce933f337.svg";
export { ForwardRef as ReactComponent };